<template>
    <div class="bg-white p-10px" style="border: 1px solid #ddd">
        <div v-if="images.length">
            <el-button
                v-if="!readOnly"
                type="primary"
                :loading="loading"
                @click="getPlacards"
                class="pull-right"
            >
                <span>Save placarding data</span>
            </el-button>
            <div>
                <img
                    v-for="image in images"
                    :key="image"
                    :src="`/static/ncbplacardimages/${image}.gif`"
                />
            </div>
            <div v-if="hasUnId">
                <img src="/static/ncbplacardimages/UNBb.gif" style="margin-right: -3px" />
                <img
                    v-for="image in unIdImages"
                    :key="image"
                    :src="`/static/ncbplacardimages/UNB${image}.gif`"
                    style="margin: 0px; padding: 0px"
                />
                <img src="/static/ncbplacardimages/UNBe.gif" style="margin-left: -3px" />
            </div>
            <div class="clearfix"></div>
        </div>
        <div v-else>
            <el-button type="primary" :loading="loading" @click="getPlacards" class="pull-right">
                <span>Save placarding data</span>
            </el-button>
            <div>Please save placarding data above</div>
            <div class="clearfix"></div>
        </div>
    </div>
</template>

<script>
import FormQuestion from '@/data/FormQuestion';
import ncbapimixin from './ncbapimixin';

export default {
    props: {
        question: { type: FormQuestion, required: true },
        form: { type: Object, required: false },
        sections: { type: Array, required: true },
        readOnly: {
            type: Boolean,
            default() {
                return false;
            },
        },
    },
    mixins: [ncbapimixin],
    data() {
        return {
            loading: false,
        };
    },
    computed: {
        allImages() {
            return this.question.data.return_value
                ? this.question.data.return_value.split(',')
                : [];
        },
        images() {
            if (this.hasUnId) {
                return this.allImages.slice(0, this.allImages.length - 1);
            }

            return this.allImages;
        },
        hasUnId() {
            const arr = this.allImages;
            if (arr.length && arr[arr.length - 1].length <= 4) {
                const value = arr[arr.length - 1];
                const re = new RegExp(/\d{4}$/);
                return re.test(value);
            }

            return false;
        },
        unIdImages() {
            return this.hasUnId
                ? this.allImages[this.allImages.length - 1].split('').join('').split('')
                : [];
        },
        repeatableSections() {
            const sections = this.sections.filter(
                (section) =>
                    !section.clientData?.isCreate &&
                    !section.clientData?.isEmpty &&
                    section.is_repeatable
            );

            return sections.length ? sections : this.sections;
        },
    },
    methods: {
        getPlacards() {
            const params = this.getRelatedQuestionsValues(this.repeatableSections);
            this.question.getPlacards({
                params: {
                    question_id: this.question.id,
                    api_params: params,
                },
                beforesend: () => {
                    this.question.data.return_value = null;
                    this.loading = true;
                },
                complete: () => {
                    this.loading = false;
                },
                success: (op, response, data) => {
                    if (data instanceof Array) {
                        this.question.data.return_value = data.join(',');
                    } else {
                        this.question.data.return_value = [];
                    }
                },
                failure: (err, response) => {
                    if (err instanceof Error) {
                        this.$notify.error({
                            title: this.$t('Error'),
                            message: err.message,
                        });
                    } else {
                        this.$notify.error({
                            title: this.$t('Error'),
                            message: response.meta.display_message,
                        });
                    }
                },
            });
        },
    },
};
</script>
